import React, { useContext } from 'react';
import LegalLayout from './LegalLayout';
import ThemeContext from '../../context/ThemeContext';
import { CGU_CONTENT } from '../../data/legalContent';

const CGUPage = () => {
  const { theme } = useContext(ThemeContext) || {};
  const isDark = theme === 'dark';

  const Section = ({ title, children }) => (
    <div className="mb-10 last:mb-0">
      <h2 className={`text-xl font-bold mb-4 flex items-center gap-3 ${
        isDark ? 'text-slate-100' : 'text-slate-900'
      }`}>
        {title}
      </h2>
      <div className={`prose max-w-none ${
        isDark ? 'prose-invert text-slate-300' : 'text-slate-600'
      }`}>
        {children}
      </div>
    </div>
  );

  return (
    <LegalLayout 
      title={CGU_CONTENT.title}
      subtitle={`Dernière mise à jour : ${CGU_CONTENT.lastUpdated}`}
    >
      <div className="space-y-8">
        {CGU_CONTENT.sections.map((section, index) => (
          <Section key={index} title={section.title}>
            {section.content.map((paragraph, pIndex) => (
              <p key={pIndex} className="mb-2">
                {paragraph}
              </p>
            ))}
          </Section>
        ))}
      </div>
    </LegalLayout>
  );
};

export default CGUPage;
